export default __webpack_public_path__ + "static/media/AJ.b7a2f6e8.png";